import { render } from "./TestMailAddresses.vue?vue&type=template&id=43fe45fa"
import script from "./TestMailAddresses.vue?vue&type=script&lang=js"
export * from "./TestMailAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__